import React from 'react'
import { Container, Row, Col } from 'react-bootstrap'
import data from '../data.js'
import Cards from './Cards.js'

const Sites = ({ id }) => {
    return (
        <Container id={id} className="pt-5">
            <Row xs={1} md={2} lg={2} >
                {data.map(site => (
                    <Col key={site.name}>
                        <Cards site={site} />
                    </Col>
                ))}
            </Row>

        </Container>
    )
}

export default Sites
